"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _material = require("@mui/material");
var _wouter = require("wouter");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _common = require("../../store/common");
var _user = require("../../store/user");
var _Style = require("../../style/Style");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const App = props => {
  const [, setLocation] = (0, _wouter.useLocation)();
  const {
    setIsLoading,
    setToastText,
    setToastOpen
  } = (0, _common.useCommonStore)();
  const {
    verifyEmail
  } = (0, _user.useUserStore)();
  (0, _react.useEffect)(() => {
    (async () => {
      setIsLoading(true);
      const result = await verifyEmail(props.token);
      if (!result) {
        setToastText('認証URLが無効です。');
      } else {
        setToastText('メールアドレス認証が完了しました。');
      }
      setToastOpen(true);
      setIsLoading(false);
      setLocation('/');
    })();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
    container: true,
    justifyContent: 'center',
    alignItems: 'center',
    ...stylex.props(_Style.wrapper.main, _Style.wrapper.noSidebar),
    spacing: 4,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      ...stylex.props(_Style.textStyle.h1),
      children: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u8A8D\u8A3C\u4E2D..."
    })
  });
};
var _default = exports.default = App;